import type { ReactNode } from 'react';

/**
 * The last-note and last-note-date cells, made a real button that opens the
 * page's one tasks-and-notes sheet on its notes (owner's decision 2026-10-04).
 * The cell's own rendering is untouched — the three states of
 * `accountLastNote` still read as they did — so the button only adds the way
 * in. Offered on every state, "No notes" included: the sheet is also where
 * the first note is written.
 *
 * Lifted out of `CompaniesPage` so the sales tracker's table can open its
 * notes the same way; one copy, so the two cannot word or style it apart.
 */
export function OpenNotesButton({
  companyName,
  onOpen,
  children,
}: {
  companyName: string;
  onOpen: () => void;
  children: ReactNode;
}) {
  return (
    <button
      type="button"
      aria-label={`Open notes for ${companyName}`}
      onClick={onOpen}
      className="-mx-1 -my-1.5 block w-[calc(100%+0.5rem)] min-w-0 cursor-pointer rounded-sm px-1 py-1.5 text-left transition-colors duration-150 ease-out hover:bg-surface-hover motion-reduce:transition-none"
    >
      {children}
    </button>
  );
}
